import {TextareaAutosize} from '@mui/material'
import 'katex/dist/katex.min.css'

export default function MarkdownTextarea(props: {value: string, onChange: (value: string) => void}) {
  return (
    <TextareaAutosize
      style={{
        width: '100%',
        backgroundColor: '#3b3b3b',
        color: '#fff',
        padding: '10px',
        fontSize: '1.1em',
        fontFamily: 'Montserrat,sans-serif'
      }}
      minRows={10}
      value={props.value || ''}
      onChange={e => props.onChange(e.target.value)}
    />
  )
}
